import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'
import Layout from 'js/magazine/components/Layout'
import { MAGAZINE_VIEW } from 'js/magazine/View/View.queries'

const View = () => {
    const params = useParams()
    const { guid } = params

    const { loading, data } = useQuery<any>(MAGAZINE_VIEW, {
        variables: {
            guid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity } = data

    return <Layout entity={entity} />
}

export { MAGAZINE_VIEW }
export default View
